import type { ru } from '../ru';
import { common } from './common';
import { shell } from './shell';
import { matches } from './matches';
import { players } from './players';
import { adminCore } from './adminCore';
import { adminTools } from './adminTools';
import { store } from './store';
import { storeTag } from './storeTag';
import { accounting } from './accounting';

export const en: typeof ru = { common, shell, matches, players, adminCore, adminTools, store, storeTag, accounting };
